import Footer from "../components/Footer";
import Header from "../components/Header";


const Faqs = () => {
    return(
        <>
            <Header />

            <div class="page-head_agile_info_w3l"></div>

            <div class="services-breadcrumb">
                <div class="agile_inner_breadcrumb">
                    <div class="container">
                        <ul class="w3_short">
                            <li>
                                <a href="/">Accueil</a>
                                <i>|</i>
                            </li>
                            <li>Faqs</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="faqs-w3l py-sm-5 py-4">
                <div class="container py-xl-4 py-lg-2">
                    <h3 class="tittle-w3l text-center mb-lg-5 mb-sm-4 mb-3">
                        <span>F</span>aqs
                    </h3>
                    <h3 class="w3-head mb-2">Le top des questions les plus posées</h3>
                    <div class="faq-w3agile">
                        <ul class="faq pl-4">
                            <li class="item1 mt-3 pl-2">
                                <a title="click here">Que veut dire OnCheck ?</a>
                                <ul>
                                    <li class="subitem1">
                                        <p> Vous voulez choisir, nous vous laissons le choix! Chez Oncheck “ON” c’est “VOUS” et “CHECK” pour la “RECHERCHE”!

                                            Chez Oncheck vous êtes sûr d’acheter le bon produit! Actuellement plus 1 millions d'offres d’environ une centaine de commerçants dans notre comparateur de prix signifient pour vous un aperçu gigantesque et très diversifié du marché.Chez OnCheck vous trouvez des avis sur d’autres marchands et produits rédigés par d’autres utilisateurs comme vous.</p>
                                    </li>
                                </ul>
                            </li>
                            <li class="item2 mt-3 pl-2">
                                <a title="click here">Comment fonctionne ce comparateur ?</a>
                                <ul>
                                    <li class="subitem1">
                                        <p> Notre gamme actuelle de produits constitue celle des plus demandées, chez OnCheck vous les avez certainement au meilleur prix. Des fonctions de filtrage et de tri complètes vous aident à trouver les produits correspondants à vos attentes, des offres personnalisées. Des rapports de test, des avis d'utilisateurs et nos textes de conseils vous aident à prendre des décisions de vente.

                                            L’historique, le rappel des prix et l'achat redirigé d’OnCheck rendent les achats à bas prix simples et confortables. Chez OnCheck vous décidez de ce que vous voulez acheter et auprès de qui et en plus quand vous voulez. Plus besoin d’attendre et de faire la queue!</p>
                                    </li>
                                </ul>
                            </li>
                            <li class="item3 mt-3 pl-2">
                                <a title="click here">Comment comparer concrètement ?</a>
                                <ul>
                                    <li class="subitem1">
                                        <p>Lorsque vous êtes sur la page d'accueil vous avez la possibilité soit de rechercher un produit,
                                            ou de choisir directement un des produits proposés. Si vous décidez de cliquer choisir un des produits directement 
                                            proposé, cliquez sur le bouton "COMPARER" qui apparait sur cet article et ainsi vous vous retrouverez
                                            sur la page comparative de ce produit.
                                            Mais si vous décidez plutôt de rechercher un produit précis, vous serez dirigé vers la page qui affichera tous les articles de cette catégorie si le mot 
                                            clé n'a pas été précis mais si ça a été le cas, vous serez dirigé directement vers la page comparative.
                                            Etant sur la page comparative, vous avez la possibilité d'acheter le produit qui vous intéresse un cliquant sur "ACHETER"
                                            et vous serez redirigé vers la page du vendeur pour finaliser l'achât.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                            <li class="item4 mt-3 pl-2">
                                <a title="click here">Comment profiter au maximum de vos services ?</a>
                                <ul>
                                    <li class="subitem1">
                                        <p>Si vous appreciez notre service de comparaison Oncheck, nous voulons vous recommander à l'inscription. C'est totalement gratuit et cela vous permet de profiter de nombreuses fonctionnalités conçues pour vous. Vous pourrez notamment faire le suivi de l'evolution du prix d'un produit, évaluer un produit, ... etc.</p>
                                    </li>
                                </ul>
                            </li>
                            <li class="item5 mt-3 pl-2">
                                <a title="click here">Quels sont les objectifs de OnCheck ?</a>
                                <ul>
                                    <li class="subitem1">
                                        <p>Nous voulons vous faire acheter au meilleur prix possible. Pour cela, nous collectons les prix des commercants proches de chez vous afin de vous assurer un service qualité-prix-proximité optimal. Vous êtes toujours assuré de trouver le prix le plus bas en haut de nos pages produit, car nul ne peut payer pour remonter sur la liste.

                                            Qui n'a pas envie d'économiser lors de ses courses. C'est le luxe que vous offre cette plateforme de comparaison transparente des prix de produits de plusierus catégories. Vous recherchez un produit, alors incrivez-le dans la barre de recherche ou passez par le menu.</p>
                                    </li>
                                </ul>
                            </li>
                            <li class="item6 mt-3 pl-2">
                                <a title="click here">Comment OnCheck gagne de l'argent ?</a>
                                <ul>
                                    <li class="subitem1">
                                        <p>Pour tous les consommateurs de prix, le service de comparaison est totalement gratuit. Nous ne vendons pas d'articles pour gagner de l’argent sur cette plate-forme et ne forçons personne à acheter plus qu'il n'en faut. Nous avons pour desir de vous guider pour réaliser le meilleur achat, quand vous le voulez.

                                            OnCheck votre comparateur de prix touche une commition chaque fois que vous êtes redirigé vers le lien des commercants avec lesquels nous avons établi une entente. Quoi qu’il en soit, nous affichons toujours l’intégralité des prix et vous avez l’assurance que ceux-ci sont toujours classés par ordre croissant. Notre service est axé principalement sur le consommateur.

                                            OnCheck se rémunère chaque fois que vous êtes redirigé vers le site Web des marchands avec lesquels nous avons signé un contrat. Quoi qu’il en soit, nous affichons toujours l’intégralité des prix connus et vous avez l’assurance que ceux-ci sont toujours classés par ordre croissant. Notre service est axé sur le consommateur.</p>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default Faqs;